import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles.css';		//tailwind styles
import './index.scss';
import App from './App';
// import AppTest from './AppTest';

import './lib.r2/utils/Globals';
import Sys from './lib.r2/utils/SystemUtils';

const container = document.getElementById('root')!;
const root = ReactDOM.createRoot(container);

let host = window.location.host
global.mode = host.startsWith('localhost') || host.includes('-dev')? '-dev' : '-prod'

let config = 'config' + global.mode + '.json'
console.log('load config:', config, '...')

Sys.loadConfig(config).then((config: any) => {
	config?
		root.render(<App/>)
		// root.render(<AppTest/>)
		: Sys.alert('error on loading config data!', false, false)
})